// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2fccd990","732":"c6f667a5","977":"be852013"}[chunkId] + ".chunk.js";
};